import React from "react";
import styles from "./styles.module.scss";
import { UICheckBox, UIText } from "src/components/uIKit";

interface CheckBoxBannerProps {
  title: string;
  subTitle: string;
  index: number;
  isChecked: boolean;
  onCheckboxChange: (index: number) => void;
}

const CheckBoxBanner: React.FC<CheckBoxBannerProps> = ({
  title,
  subTitle,
  index,
  isChecked,
  onCheckboxChange,
}) => {

  const handleCheckboxChange = () => {
    onCheckboxChange(index);
  };

  return (
    <div className={styles.cardItem} tabIndex={0}>
      <UICheckBox checked={isChecked} onChange={handleCheckboxChange} />
      <div className={styles.cardDetails}>
        <UIText text={title} size={18} weight={500} />
        <UIText text={subTitle} size={15} weight={400} />
      </div>
    </div>
  );
};

export default CheckBoxBanner;
